import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useTranslate from '~hooks/useTranslate/useTranslate';
import OperatorDetails from 'gatsby-matrix-theme/src/components/molecules/operator-details';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus-box/template-three';

import { getExtraField } from 'gatsby-core-theme/src/helpers/getters';
import { TiArrowSortedDown } from '@react-icons/all-files/ti/TiArrowSortedDown';
import { TrackingKeys } from '~constants/tracking-api'

import styles from './variant-one.module.scss';

export default function Row({
  item,
  moduleName = TrackingKeys?.TOPLIST,
  tracker = 'main',
  oneliner='main',
  index,
  className,
  itemRefs,
  template,
  modulePosition,
  itemPosition,
}) {
  const [open, setOpen] = useState(false);

  const winRate = getExtraField(item.extra_fields, 'win_rate') || '-';
  const payoutSpeed = getExtraField(item.extra_fields, 'payout_speed') || '-';

  const ribbons = item.ribbons;
  const cardClass = `card${index + 1}`;

  const addToRefs = (el, itemNum) => {
    if (el && itemRefs) {
      itemRefs.current[itemNum] = el;
    }
  };

  return (
    <>
      <li
        className={`${className} ${styles.list}  ${styles[cardClass] ? styles[cardClass] : ''}`}
        ref={(el) => addToRefs(el, index)}
      >
        <OperatorDetails
          item={item}
          prettyLinkTracker
          template={template}
          tracker={tracker}
          costumeStyle={styles.operatorDetails}
          imageWidth={index > 2 ? 120 : 80}
          imageHeight={index > 2 ? 120 : 80}
          ribbons={ribbons}
          reviewNoFollow={false}
          showRibbon={false}
          showAuthor={false}
          modulePosition={modulePosition}
          itemPosition={itemPosition}
          moduleName={moduleName}
        />
        <div className={styles.boxesContainer}>
          <div className={styles.boxes}>
            <p>{useTranslate('win_rate', 'Win Rate:')}</p>
            <span>{`${winRate}${winRate !== '-' ? '%' : ''}`}</span>
          </div>
          <div className={styles.boxes}>
            <p>{useTranslate('payout', 'Payout:')}</p>
            <span>{payoutSpeed}</span>
          </div>
        </div>

        <Bonus
          welcomeBonus={false}
          item={item}
          pageTemplate={template}
          ctaBtn
          tracker={oneliner}
          variableInsideContainer
          moduleName={moduleName}
          modulePosition={modulePosition}
          itemPosition={itemPosition}
        />

        <button onClick={() => setOpen(!open)} className={styles.showFeatures}>
          {open
            ? useTranslate('show_less', 'Show less')
            : useTranslate('more_top_features', 'More Top Features')}
          <TiArrowSortedDown className={`${open && styles.arrowTop}`} />
        </button>

        {open && (
          <div className={`${styles.moreFeatureContainer} ${open && styles.transitionEffect}`}>
            <div className={styles.topFeatures}>
              <p>{useTranslate('top_features', 'Top Features:')}</p>
              <ul>
                {item?.selling_points?.map((item) => (
                  <li>{useTranslate(item, item)}</li>
                ))}
              </ul>
            </div>
            <div className={`${styles.boxes} ${styles.boxesCol}`}>
              <p>{useTranslate('min_deposit', 'Min Deposit:')}</p>
              <span>{item?.min_deposit || '-'}</span>
            </div>
            <div className={`${styles.boxes} ${styles.boxesCol}`}>
              <p>{useTranslate('max_withdraw', 'Max Withdrawals:')}</p>
              <span>{item?.max_withdrawal || '-'}</span>
            </div>
          </div>
        )}

        {ribbons?.length > 0 && (
          <span className={styles.ribbon}>{ribbons.slice(0, 1).map((r) => r)}</span>
        )}
      </li>
    </>
  );
}

Row.propTypes = {
  tracker: PropTypes.string,
  oneliner: PropTypes.string,
  layout: PropTypes.oneOf(['list', 'grid']),
  item: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
    rating: PropTypes.string,
    currencies: PropTypes.arrayOf(PropTypes.string),
    review_link: PropTypes.string,
    one_liners: PropTypes.shape({
      main: PropTypes.shape({
        one_liner: PropTypes.string,
      }),
    }),
    extra_fields: PropTypes.shape({
      terms_and_conditions_text_enabled: PropTypes.string,
      ribbon_text: PropTypes.string,
      ribbon_color: PropTypes.string,
    }),
    bonus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    relation: PropTypes.shape({
      rating: PropTypes.string,
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  }).isRequired,
  number: PropTypes.number,
  isPPC: PropTypes.bool,
  className: PropTypes.string,
};
